import { useQuery } from 'react-query';

import * as userApi from 'resources/user/user.api';

export default function useGetRealtors(queryOptions) {
  return useQuery(
    ['users.getRealtors'],
    () => userApi.getRealtors(),
    queryOptions,
  );
}
